import { useMenu } from 'src/contexts/menu-context'
import type { ListMenuProps } from '../../../global-navigation'
import { hasNextLevel, trackMenuPathDesktop } from '../../../utils'
import { LinkItem } from './LinkItem'
import { ParentItem } from './ParentItem'

export const ListMenu = ({ menu, type, level }: ListMenuProps) => {
  const { state } = useMenu()

  const handleTrack = () => {
    trackMenuPathDesktop(Number(level ?? type) - 1, state)
  }

  return (
    <>
      <div className="px-6 pt-10 pb-4 mb-3">
        <div className="px-3 min-h-[32px]">
          <a
            style={{ color: menu.titleColor ? menu.titleColor : '#0A0A0A' }}
            className={`font-bold text-2xl tracking-[-0.48px] ${
              menu.titleURL ? 'hover:underline' : ''
            }`}
            href={menu.titleURL ? menu.titleURL : undefined}
            onClick={handleTrack}
          >
            {menu?.title}
          </a>
        </div>
        <div className="px-3 pt-10">
          {menu?.items?.map((el, index: number) =>
            hasNextLevel(el) ? (
              <ParentItem
                item={el}
                type={type}
                level={level}
                position={index}
                key={`parent-item-${index}`}
              />
            ) : (
              <LinkItem
                item={el}
                type={type}
                level={level}
                position={index}
                key={`link-item-${index}`}
              />
            )
          )}
        </div>
      </div>
    </>
  )
}
